import { render, staticRenderFns } from "./SfChevron.vue?vue&type=template&id=0f0b2317&"
import script from "./SfChevron.vue?vue&type=script&lang=js&"
export * from "./SfChevron.vue?vue&type=script&lang=js&"
import style0 from "./SfChevron.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports